<template>
    <div>
        <Card
            :noColors="true"
            :class="{
                'border border-booking-form-theme-main-background-color ring-1 ring-inset ring-booking-form-theme-main-background-color':
                    isSelected,
                'border border-gray-200': !isSelected,
            }"
        >
            <template #content>
                <div class="relative">
                    <div
                        v-if="isSelected"
                        class="absolute -top-1 -right-1"
                    >
                        <Icon
                            name="circle-check"
                            class="w-6 h-6 text-booking-form-theme-main-background-color"
                        />
                    </div>
                    <div class="grid grid-cols-10 gap-4 items-center">
                        <div class="col-span-8">
                            <div class="text-gray-600 text-sm">
                                ****
                                {{
                                    customerPaymentMethod.cardPaymentMethodData
                                        ?.cardLast4
                                }}
                                -
                                {{
                                    customerPaymentMethod.cardPaymentMethodData
                                        ?.cardBrand
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import CustomerPaymentMethod from '@/App/CustomerPaymentMethod/Entity/CustomerPaymentMethod'
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        customerPaymentMethod: {
            type: Object as PropType<CustomerPaymentMethod>,
            required: true,
        },
        isSelected: {
            type: Boolean,
            required: true,
        },
    })
</script>
